import { PaginationParams } from '../general-store/general.model';
import { PublicExperience } from './public-experience.model';

const CONTEXT = '[PublicExperienceStore]';

export class GetPublicExperienceList {
  static readonly type = `${CONTEXT} Get Public Experience List`;
  constructor(public payload: PaginationParams) {}
}

export class GetAllPublicExperiences {
  static readonly type = `${CONTEXT} Get All Public Experiences`;
}

export class GetPublicExperience {
  static readonly type = `${CONTEXT} Get Public Experience`;
  constructor(public id: number) {}
}

export class CreatePublicExperience {
  static readonly type = `${CONTEXT} Create Public Experience`;
  constructor(public payload: PublicExperience) {}
}

export class DeletePublicExperience {
  static readonly type = `${CONTEXT} Delete Public Experience`;
  constructor(public id: number) {}
}

export class UpdatePublicExperience {
  static readonly type = `${CONTEXT} Update Public Experience`;
  constructor(
    public payload: PublicExperience,
    public id: number,
  ) {}
}

export class DuplicatePublicExperience {
  static readonly type = `${CONTEXT} Duplicate Public Experience`;
  constructor(public id: number) {}
}

export class ClearPublicExperience {
  static readonly type = `${CONTEXT} Clear Public Experience`;
  constructor() {}
}
export class ClearNewPublicExperience {
  static readonly type = `${CONTEXT} Clear New Public Experience`;
  constructor() {}
}
export class GetAllDefaultModules {
  static readonly type = `${CONTEXT} Get All Default Modules`;
  constructor() {}
}

export class BulkUpdatePublicExperience {
  static readonly type = `${CONTEXT} Bulk Update Public Experience`;
  constructor(public payload: BulkUpdatePublicExperiencePayload) {}
}

export interface BulkUpdatePublicExperiencePayload {
  publicExperienceId: number;
  modulesToAdd: Array<{
    moduleId: number;
    templateId: number;
    tempId: string;
    tempModuleId?: number;
    moduleData?: {
      title: string;
      slug: string;
      order: number;
      styles: any;
      rules: any;
      pageModuleTemplateDataContents: any[];
    };
  }>;
  modulesToDelete: number[];
  modulesToUpdate: Array<{
    id: number;
    [key: string]: any;
  }>;
  modulesToReorder: Array<{ id: number; order: number }>;
  componentsToAdd: Array<any>;
  componentsToDelete: Array<{ id: number; moduleId: number }>;
  componentsToUpdate: Array<{
    id: number;
    [key: string]: any;
  }>;
  componentsToReorder: Array<{ id: number; order: number; moduleId: number }>;
}
